import { Container } from "@material-ui/core"
import { connect } from "react-redux"
import { Route } from "react-router-dom"
import AppPanel from "../AppPanel"
import NotFoundContent from "./NotFoundContent"

function PermissionRoute({ children, user, permissions, ...rest }) {
  return (
    <Route
      {...rest}
      render={() =>
        permissions.includes(user.type) ? (
          children
        ) : (
          <AppPanel>
            <Container maxWidth={false}>
              <NotFoundContent />
            </Container>
          </AppPanel>
        )
      }
    />
  )
}

const mapStateToProps = (state) => {
  return { user: state.user }
}

export default connect(mapStateToProps)(PermissionRoute)
